// extracted by mini-css-extract-plugin
export default {"row":"Earning_row__XozZ6","col":"Earning_col__IvLm4","card":"Earning_card__mojKU"};